import styled from 'styled-components';
import Theme from '../../themes/green';

const ProjectName = styled.div`
  color: ${Theme.pallete.background};
  font-weight: 600;
  margin-right: 10px;
`;

ProjectName.propTypes = {};

ProjectName.defaultProps = {};

export default ProjectName;



// WEBPACK FOOTER //
// ./src/components/ProjectName/index.js